import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import ApiService from "@/core/services/api.service";
import MockService from "@/core/mock/mock.service";
import { VERIFY_AUTH } from "@/core/services/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";

Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import "@/core/plugins/formvalidation";
import VueAnalytics from 'vue-analytics';



// API service init
ApiService.init();

// Remove this to disable mock API
MockService.init();

const prod = process.env.NODE_ENV === 'production'
const shouldSW = 'serviceWorker' in navigator && prod
if (shouldSW) {
    navigator.serviceWorker.register('/service-worker.js').then(() => {
        console.log("Service Worker Registered!")
    })
}

router.beforeEach((to, from, next) => {
    // Ensure we checked auth before each page load.
    store.dispatch(VERIFY_AUTH).then(() => {
        const isAuthenticated = store.getters.isAuthenticated;

        // Define public routes
        const publicRoutes = ['login', 'register', 'error', '404'];
        const isPublic = publicRoutes.some(route => to.name && to.name.toLowerCase().includes(route));

        if (!isAuthenticated && !isPublic) {
            // If not authenticated and trying to access a protected route, redirect to login
            next({ name: "login" });
        } else {
            // Otherwise, continue
            next();
        }
    });

    // reset config to initial state
    store.dispatch(RESET_LAYOUT_CONFIG);

    // Scroll page to top on every route change
    setTimeout(() => {
        window.scrollTo(0, 0);
    }, 100);
});

window.OneSignal = window.OneSignal || [];
window.OneSignal.push(() => {
    window.OneSignal.init({
        appId: "f2b4086e-6625-40ef-b55a-c9921d88676b",
        allowLocalhostAsSecureOrigin: true,
    });
});


// Configuration VueAnalytics
Vue.use(VueAnalytics, {
    id: 'G-4BREDRFNR6',
    router
});

new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: h => h(App),
}).$mount("#app");